import React from 'react'
import './Interior.css'
import Other from '../Components/Navbar/Other'
import Footer from '../Components/Navbar/Footer'
import special from '../Assets/accessories/accesories-about.png'
import Access from '../Components/Navbar/Access'

const InteriorEmulsions = () => {
    return (
        <div>
            <div className="accessories-banner-wrapper banner-layout2">
                <div className="about-banner-img"></div>
                <div className="home-banner-content ">
                    <div className='container-fluid'>
                        <h1>Perfect Finish Starts with the Right Tools</h1>
                    </div>
                </div>
            </div>

            <div className='container-fluid bodybg' style={{ paddingTop: "70px" }}>
                <div className='row'>
                    <div className='col-12 col-sm-6 col-md-6 '>
  <h1 className='htag'>Perfect Tools for a Flawless Finish</h1> <br/>
  <p className='mt-3'>
    Lenox Paints offers a complete range of high-quality painting accessories designed to deliver smooth application and professional results. From durable brushes and precision rollers to premium wall putty for a perfectly prepared surface, our products ensure every coat looks its best. Whether you're working on interiors or exteriors, our accessories help you achieve superior coverage, clean edges, and long-lasting finishes with ease.
  </p>
</div>

                    <div className='col-12 col-sm-6 col-md-6'>
                        <img src={special} alt='interior emulsions'></img>
                    </div>
                </div>


                <div className='bodybg' style={{ paddingTop: "70px" }}></div>
                <Access />
            </div>
            <div className='bodybg' style={{ paddingTop: "70px" }}></div>
       
            <Footer/>
        </div>
    )
}

export default InteriorEmulsions